import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import {useEvent} from 'Event/EventProvider'
import {ObieAttendeeLink} from 'lib/event-api/integrations/obie/attendee-links/list'
import {useUpdateObieAttendeeLink} from 'lib/event-api/integrations/obie/attendee-links/update'
import Dialog from 'lib/ui/Dialog'
import AttendeeLinkForm from 'organization/Event/Services/Apps/Obie/Config/AttendeeLinks/AttendeeLinkForm'
import {useOrganization} from 'organization/OrganizationProvider'
import React from 'react'

export interface EditAttendeeLinkDialogProps {
  link: ObieAttendeeLink
  obieHubId: string
  onClose: () => void
}

export default function EditAttendeeLinkDialog(
  props: EditAttendeeLinkDialogProps,
) {
  const {link, obieHubId, onClose} = props
  const {event} = useEvent()
  const {client} = useOrganization()
  const updateLink = useUpdateObieAttendeeLink({client, event, link})

  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>Edit attendee link</DialogTitle>
      <DialogContent>
        <AttendeeLinkForm
          obieHubId={obieHubId}
          link={link}
          isSaving={updateLink.isLoading}
          error={updateLink.error}
          submitLabel="Save changes"
          onSubmit={(data) => updateLink.mutate(data, {onSuccess: onClose})}
        />
      </DialogContent>
    </Dialog>
  )
}
